export enum BonusType {
  CONSTANT_BONUS = 'CONSTANT_BONUS',
  DISCRETIONARY_BONUS = 'DISCRETIONARY_BONUS',
}
